import React from 'react';
import './style.scoped.scss';

const TitleBar = ({ pageTitle, compact = false }) => {
  return (
    <div className={`titleBar ${compact ? 'titleBar--compact' : ''}`}>
      {compact ? (
        <h5 className='titleBar__title mr-0 mb-0'>{pageTitle}</h5>
      ) : (
        <h2 className='titleBar__title mr-0 mb-0'>{pageTitle}</h2>
      )}
    </div>
  );
};

export default TitleBar;
